<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div
      class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25"
    >
      <div class="d-sm-flex align-items-center"></div>
      <div class="d-flex align-items-center">
        <input
          type="text"
          class="form-control shadow-none text-black rounded-0"
          placeholder=""
          v-model="searchTerm"
          @input="handleInput"
          @change="getRecords"
        />
      </div>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <vue-good-table :columns="columns" :rows="rows" responsive>
        <template v-slot:emptystate>
          <center>Aucune entrées correspondants trouvés</center>
        </template>
        <template v-slot:table-row="props">
          <span v-if="props.column.field === 'invoice_ref'" class="text-nowrap">
            <b>{{ props.row.invoice_ref }}</b>
          </span>
          <span
            v-else-if="props.column.field === 'created_at'"
            class="text-nowrap"
          >
            <span v-if="props.row.created_at != null">
              {{ getDate(props.row.created_at) }}
            </span>
            {{ props.row.create_by_name }}
          </span>
          <span
            v-else-if="props.column.field === 'paid_time'"
            class="text-nowrap"
          >
            <span v-if="props.row.paid_time != null">
              {{ getDate(props.row.paid_time) }}
            </span>
            {{ props.row.paid_by_name }}
          </span>
          <span
            v-else-if="props.column.field === 'total_to_send'"
            class="text-nowrap"
          >
          {{ props.row.total_to_send }}  Dhs
          </span>

          <template v-else-if="props.column.field === 'statut'">
            <span
              v-if="props.row.statut === 0"
              class="badge rounded-pill bg-danger text-capitalize"
            >
              Brouillon
            </span>
            <span
              v-else-if="
                props.row.statut === 1 &&
                props.row.virement_id === 0 &&
                !props.row.virement_ref
              "
              class="badge rounded-pill bg-warning text-capitalize"
            >
              Enregistré
            </span>
            <span
              v-else-if="
                props.row.paid === 1 &&
                props.row.statut === 2 &&
                props.row.virement_id != 0 &&
                props.row.virement_ref
              "
              class="badge rounded-pill bg-success text-capitalize"
            >
              Payé
            </span>
            <span
              v-else-if="props.row.virement_id != 0 && props.row.virement_ref"
              class="badge rounded-pill bg-info text-capitalize"
            >
              Virement
            </span>
          </template>
          <template v-else-if="props.column.field === 'action'">
            <div class="btn-group">
              <tempalte v-if="props.row.parcels_num != 0">
                <button
                  class="dropdown-item"
                  @click="getPDF(props.row)"
                >
                  <i class="flaticon-file"></i> Télécharger
                </button>
              </tempalte>
            </div>
          </template>
          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>
      </vue-good-table>

      <PaginatorContent
        :pagination="users"
        :offset="9"
        @paginate="getRecords"
      />
    </div>
  </div>
</template>

<script>
import api from "@/utils/axios";
import { defineComponent, onMounted, ref } from "vue";
import { useAuthStore } from "../../stores/auth";
import { useAppToast } from "@/composables/useAppToast";
import moment from "moment";

export default defineComponent({
  name: "InvoiceList",
  setup() {
    const { showToast } = useAppToast();
    const auth = useAuthStore();
    const user = auth.user;
    const columns = [
      {
        label: "Référence",
        field: "invoice_ref",
      },
      {
        label: "Date de création",
        field: "created_at",
      },
      {
        label: "Statut",
        field: "statut",
      },
      {
        label: "Date de paiement",
        field: "paid_time",
      },
      {
        label: "Colis",
        field: "parcels_num",
      },
      {
        label: "Total",
        field: "total_to_send",
      },
      {
        label: "Actions",
        field: "action",
        width: "180px",
      },
    ];

    const rows = ref([]);
    const CustomerList = ref([]);
    const StoresList = ref([]);
    const client_filter = ref({ id: "", name: "" });
    const store_filter = ref({ id: "", name: "" });
    const type_date_filter = ref("");
    const status_filter = ref("");
    const date_filter = ref("");
    const total_filter = ref("");
    const StatusList = ref([]);
    const users = ref({
      searchTerm: "",
      searchCustomer: "",
      searchLiv: "",
      searchCity: "",
      searchEtat: "",
      searchAStatut: "",
      searchDateFrom: "",
      searchDateTo: "",
      total: 0,
      per_page: 10,
      from: 1,
      to: 0,
      current_page: 1,
    });
    const offset = ref(9);

    const row_ref = ref({});
    const pricePaid = ref(0);
    const selectedRows = ref([]);
    const Invoices = ref([]);
    const rowsCustomer = ref([]);
    const AutoInvoices = ref([]);

    const searchTimeout = ref(null);

    function getDate(value) {
      // If using moment.js
      return  moment(String(value)).format("YYYY-MM-DD HH:mm");
    }

    function resolveUserStatusVariant(status) {
      if (status === 0) return "danger";
      if (status === 1) return "info";
      if (status === 2) return "success";
      return "warning";
    }

    const isLoader = ref(false);

    async function getRecords( page = 1) {
      isLoader.value = true;
      users.value.current_page = page; // ✅ update the current page
      try {
       const response = await api
        .get(
          `/api/auth/client/invoices_list?searchTerm=${users.value.searchTerm}&page=${users.value.current_page}&per_page=${users.value.per_page}`
        )
          rows.value = response.data.users.data;
          users.value = response.data.users;
        
        } catch (error) {
        console.error("Erreur lors du chargement des enregistrements:", error);
      } finally {
        isLoader.value = false;
      }
    }
    const debounceTimer = ref(null);
    const searchTerm = ref("");

    function handleInput() {
      clearTimeout(debounceTimer.value);
      debounceTimer.value = setTimeout(() => {
        if (!searchTerm.value || searchTerm.value === "") {
          users.value.searchTerm = searchTerm.value;
          filter();
        } else if (searchTerm.value && searchTerm.value.length > 2) {
          users.value.searchTerm = searchTerm.value;
          filter();
        }
      }, 500);
    }

    function convert(str) {
      const date = new Date(str);
      const mnth = `0${date.getMonth() + 1}`.slice(-2);
      const day = `0${date.getDate()}`.slice(-2);
      return [date.getFullYear(), mnth, day].join("-");
    }

     function Removefilter() {
      users.value.searchTerm = "";
      users.value.current_page = 1;
      getRecords();
    }

    function filter() {
      users.value.current_page = 1;
      getRecords();
    }


    function getPDF(row) {
      api
        .get(`/api/auth/client/InvoicePdf/${row.id}`, {
          responseType: "arraybuffer",
        })
        .then((response) => {
          const blob = new Blob([response.data], { type: "application/pdf" });
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          window.open(link.href, "_blank");
        });
    }

    function PDFTransfer(row) {
      api
        .get(`/api/auth/TransfertPDF/${row.virement_id}`, {
          responseType: "arraybuffer",
        })
        .then((response) => {
          const blob = new Blob([response.data], { type: "application/pdf" });
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          window.open(link.href, "_blank");
        });
    }

    onMounted(async () => {
      getRecords();
    });

    return {
      columns,
      rows,
      CustomerList,
      StoresList,
      client_filter,
      store_filter,
      type_date_filter,
      status_filter,
      date_filter,
      total_filter,
      StatusList,
      users,
      offset,
      row_ref,
      pricePaid,
      selectedRows,
      Invoices,
      rowsCustomer,
      AutoInvoices,
      searchTimeout,
      getDate,
      resolveUserStatusVariant,
      isLoader,
      getRecords,
      Removefilter,
      filter,
      debounceTimer,
      searchTerm,
      handleInput,
      convert,
      getPDF,
    };
  },
});
</script>